import type { FaireProductEntity } from "../../entity_types/product";

export const p_h729mty5gg: FaireProductEntity = {
  token: "p_h729mty5gg",
  type: "product",
  name: "Triple Layer Dainty Gold Chain NG033",
  brandToken: "b_dmzj4e52w6",
  brandName: "AAJewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/490c2d74b0da5424d2a81a55d00c72ad126e0623765fccaea37d37ae7eccb7bc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5ea7294e4b375badfef2805d5de7d7f0e748ac5d5f19a3f84b549ada065de7f3.jpeg",
    "https://cdn.faire.com/fastly/1d5ebc7eca9f988b676d4904f3bb98070682940cb5b0d0e23a19d4cf710802ac.jpeg",
    "https://cdn.faire.com/fastly/62bab681b4700901c3c8ca536c1fa897f2285673a95ed49e9aae8de6976b534b.jpeg",
    "https://cdn.faire.com/fastly/85a3dc2d59c23b258d7e9fc79746cf82c5104fe54a0c163d18113226e444da2a.jpeg",
    "https://cdn.faire.com/fastly/af963056f73c3dfa225b4f2d785a2491e01258fbba9528deaa9ab955906dc44f.jpeg",
    "https://cdn.faire.com/fastly/b703c472363b85022d4d4ef7fb85a6c09652ed3ac581223c2dd88762209d8a0a.jpeg",
  ],
  priceDollars: 16.63,
  description:
    'An effortless layered gold necklace featuring three delicate chains with tiny bead accents for soft texture and shine. Designed for an instant stacked look without the hassle of layering. Lightweight, minimal, and perfect for everyday wear or dressing up.\n\nPRODUCT QUALITY\nExpertly handcrafted from sterling silver and stainless steel, our jewelry features thick gold and rhodium plating for lasting shine. Finished with durable 18k PVD coating adding extra layers of genuine gold, each piece stays brilliant and resists daily wear for years to come.\n\nDETAILS\n▪ Necklace 1 Length: 15.75" + 2" Ext   \n▪ Necklace 2  Length: 17.72" + 2" Ext   \n• Necklace 3 Length: 19.69" + 2" Ext   \n▪ Thick 18k gold plated - high-quality medical 316L stainless steel\n▪ Hypoallergenic ▪ Nickel-free ▪ Non tarnish ▪ Water Resistant',
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:52.889Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
